import { PortalApiClient } from '../portalApiClient';

export async function acceptDisclaimer(
  version: number,
  client: PortalApiClient
) {
  try {
    const response = await client.http.request({
      path: '/api/v1/users/me/disclaimer',
      method: 'PUT',
      secure: true,
      body: { disclaimer_version: version },
    });
    if (!response?.ok) {
      const data = await response.json();
      throw new Error(data.error ?? 'Updating disclaimer version failed.');
    }
  } catch (e: unknown) {
    console.error(e);
    throw e;
  }
}
